var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"small-link-item",on:{"click":_vm.clickItem}},[_c('Loading',{attrs:{"visible":_vm.loading}}),_c('span',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"arrow-right"},[_c('font-awesome-icon',{attrs:{"icon":"chevron-right"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }